import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeleteTextBtn',
  setup() {
    return {}
  },
})
